<template>
  <div class="with-us">

    <div id="mission" class="page-header">
      <div class="page-header-wrap">
        <img alt="" class="abs" src="/assets/images/work-with-us-header.png">

        <div class="wrapper">
          <div class="page-title">
            <h2>Working at Forestal</h2>
            <div class="page-sub-title">We believe in a technologically advanced ecosystem where nature,
              technology and people coexist in harmony.
            </div>
          </div>
        </div>

        <div v-scroll="handleScroll" class="main__navbox">
          <div class="wrapper">
            <nav class="navbox">
              <ul>
                <li>
                  <a href="#mission-scroll" @click="goToBlock">Mission</a>
                </li>
                <li>
                  <a class="nav-active-flow" href="#atmosphere" @click="goToBlock">Atmosphere</a>
                </li>
                <li>
                  <a href="#internships" @click="goToBlock">Internships</a>
                </li>
                <li>
                  <a href="#all" @click="goToBlock">All job offers</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content indent2">
      <div class="wrapper">
        <div id="mission-scroll" class="section text text-bold indent">
          <p ref="mission">Our mission is to bring a new spirit to the cycling industry and create the innovative
            products
            today for tomorrow.</p>
        </div>
        <div class="section text text-sub indent">
          <p>As a member of the Forestal family, you will have the opportunity to unleash your professional
            talent and develop your career while enjoying an international, dynamic and passionate
            environment with great company culture.</p>
        </div>
        <div class="section image indent2">
          <img alt="Forestal" src="/assets/images/work-with-us-mission.png">
        </div>
        <div class="section text text-bold center indent2">
          <p>Do you want to participate in projects that inspire the world with unimaginable?
            <span class="green">At Forestal we are committed to employee success, joy and growth.</span>
          </p>
        </div>
      </div>

      <div
        id="atmosphere"
        ref="atmosphere"
        class="divider image indent"
      >
        <img alt="" src="/assets/images/work-with-us-mission-divider.jpg">
      </div>

      <div class="wrapper indent2">
        <div class="section text text-bold indent">
          <p>Atmosphere</p>
        </div>

        <div class="section text text-sub indent2">
          <p>A place to work with no walls or barriers between departments, where creativity and information
            flow from one side to another with one common goal; inspire the world with the unimaginable
            through our brand.</p>
        </div>

        <div class="section section-row indent2">
          <div class="section-item">
            <div class="bold">50+</div>
            <div class="sub">employees</div>
          </div>
          <div class="section-item">
            <div class="bold">8000+</div>
            <div class="sub">m<sup>2</sup> space</div>
          </div>
          <div class="section-item">
            <div class="bold">Pyrenees</div>
            <div class="sub">around you</div>
          </div>
        </div>

        <div class="section image indent">
          <img alt="Forestal" src="/assets/images/work-with-us-mission-2.png">
        </div>

        <div class="section text text-sub indent2">
          <p>Forestal is that one company that gets as close as what a dream job could be, where you can work
            on what has always been your passion, with a good salary and opportunity for growth within a
            stable project, enjoying the most advanced and modern offices inside the exclusive Forestal
            Technology Centre, and yet be able to look through the window and be amazed by a beautiful
            landscape that will keep filling your spirit day by day.</p>

          <p>You will have the privilege to enjoy every day of activities such as road cycling, mountain
            biking, hiking, climbing and all sort of winter sports too in an internationally recognized
            location for which many people around the world are looking forward to traveling on their
            holidays.</p>
        </div>

        <div class="section image indent">
          <flickity ref="flickity" :options="flickityOptions">
            <div class="carousel-cell"><img alt="Forestal" src="/assets/images/work-with-us-mission.png">
            </div>
            <div class="carousel-cell"><img alt="Forestal" src="/assets/images/work-with-us-mission-2.png">
            </div>
          </flickity>
        </div>

        <div class="section text text-bold indent">
          <p>What it is like to be working at Forestal?</p>
        </div>

        <div class="section text text-sub indent2">
          <p>Forestal was born and is settled in Andorra, right in the heart of the Pyrenees. A pretty small
            but authentic country, perhaps one of the best places to live if you’re looking forward to being
            surrounded by nature and sports passionates, as well as to raise a family in one of the safest
            counties in the world with a high-quality standard of living.</p>

          <p>Combine this with the fact of working in a Team with the most talented bike industry, motorsports
            and technology enthusiasts developing amazing and challenging projects, and you’ve got a perfect
            cocktail for a lifestyle.</p>
        </div>

        <div class="section text text-bold center">
          <p>You will be surrounded by highly-qualified professionals coming from different backgrounds and
            who can provide a vast amount of experience to your learning processes, from engineers, IT
            developers, designers and marketeers.</p>
        </div>
      </div>

      <div id="internships"
           class="divider image indent">
        <img alt="" src="/assets/images/work-with-us-mission-divider-2.jpg">
      </div>

      <div ref="internships" class="wrapper indent2">
        <div class="section text text-bold indent">
          <p>Internships</p>
        </div>

        <div class="section text text-sub">
          <p>Gain work experience and kickstart your career at Forestal. We offer many opportunities to
            grow with us from the start and promise attention to your ideas, a comfortable office in
            Andorra, a productive environment, and a friendly working atmosphere. Can’t travel? No
            worries, explore our Virtual internship opportunities.</p>

          <p>Become a part of a diverse Forestal family sending us your cover letter to
            <a href="mailto:jobs@forestal.com"><strong>jobs@forestal.com</strong></a>. Tell us about
            yourself!</p>
        </div>
      </div>

      <div class="divider green">
        <div class="wrap">
          <p>We are creating history today. <br>Do you want to write it with us?</p>
        </div>
      </div>
    </div>

    <div v-if="departmentsForSelect.length > 0" id="all" ref="all" class="wrapper indent2">
      <div class="vacancies">
        <h2 class="indent">Working at Forestal</h2>

        <div class="vacancy-categories-list">
          <div :class="isActiveDepartment(0)"
               class="category-title"
               @click="selectDepartment(0)">All
          </div>
          <div v-for="department in departmentsForSelect"
               :class="isActiveDepartment(department.id)"
               class="category-title"
               @click="selectDepartment(department.id)">
            {{ getDepartmentTitle(department) }}
          </div>
        </div>

        <div v-if="showVacancies(0)" class="vacancy-wrap">
          <div v-for="vacancy in visibleVacancies" class="vacancy-box">
            <div class="vacancy">
              <div class="category">{{ getDepartmentTitleForVacancy(vacancy) }}</div>
              <div class="title">
                <a :href="getVacancyUrl(vacancy)">{{ getVacancyTranslate(vacancy, 'title') }}</a>
              </div>
              <div
                class="description"
                v-html="getVacancyTranslate(vacancy, 'short_description')">
              </div>
            </div>
          </div>
        </div>

        <div v-if="!showVacancies(0)">
          <div class="no-vacancy">
            <p>Currently we don't have any open positions in this department, but if you are interested in
              possible future
              opportunities please send us your CV to <a class="green"
                                                         href="mailto:jobs@forestal.com">jobs@forestal.com</a>
            </p>
          </div>
        </div>

        <div v-if="isShowMore" class="show-all" @click="showMore()">
          <span v-if="!showFull">Show all</span>
          <span v-if="showFull">Show less</span>
        </div>
      </div>
    </div>
    <div v-if="departmentsForSelect.length > 0" class="wrapper indent2">
      <cv-form
        :departments="departments"
        :departmentsForSelect="departmentsForSelect"
        :lang="lang"/>
    </div>

    <div class="page-content indent2">
      <div class="wrapper">
        <div class="section text text-bold center w-4-5">
          <p>If you have not found a suitable job offer, feel free to apply on your own initiative
            <span class="green">
                <a href="mailto:jobs@forestal.com">jobs@forestal.com</a>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Flickity from 'vue-flickity'

export default {
  name: "with-us",
  props: ['departments', 'lang'],
  components: {Multiselect, Flickity},

  data: () => ({
    flickityOptions: {
      imagesLoaded: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      adaptiveHeight: true,
    },
    departmentsForSelect: [],
    currentDepartment: 0,
    vacancies: [],
    showFull: false,
  }),
  computed: {
    visibleVacancies() {
      let vacancies = [];
      if (this.currentDepartment === 0) {
        vacancies = [...this.vacancies]
        if (!this.showFull) {
          vacancies = vacancies.splice(0, 4)
        }
      } else {
        vacancies = [...this.vacancies].filter(item => {
          return parseInt(item.department_id) === this.currentDepartment
        })

        if (!this.showFull) {
          vacancies = vacancies.splice(0, 4)
        }
      }

      return vacancies
    },
    isShowMore() {
      return this.showVacancies(4)
    }
  },
  mounted() {
    this.departmentsForSelect = this.departments;
    let vacancies = [];

    for (let department of this.departmentsForSelect) {
      if (department.hasOwnProperty('vacancies') && department.vacancies.length > 0) {
        for (let vacancy of department.vacancies) {
          vacancies.push(vacancy)
        }
      }
    }

    this.vacancies = vacancies
  },
  methods: {
    showVacancies(count = 0) {
      if (this.currentDepartment === 0) {
        return this.vacancies.length > count
      }

      let vacancies = [...this.vacancies].filter(item => {
        return parseInt(item.department_id) === this.currentDepartment
      })

      return vacancies.length > count
    },
    showMore() {
      this.showFull = !this.showFull
    },
    selectDepartment(id) {
      this.showFull = false
      this.currentDepartment = parseInt(id)
    },
    isActiveDepartment(id) {
      return {
        active: this.currentDepartment === parseInt(id)
      }
    },
    getDepartmentTitle(department) {
      let postfix = ''

      if (this.lang !== 'en') {
        postfix = `_${this.lang}`
      }

      if (department[`title${postfix}`]) {
        return department[`title${postfix}`]
      }

      return department.title
    },
    getDepartmentTitleForVacancy(vacancy) {
      let department = '';
      department = this.departments.find(item => {
        return item.id === vacancy.department_id
      })

      if (department) {
        return department.title
      }

      return department;
    },
    getVacancyTranslate(vacancy, field) {
      if (field === 'short_description' && !vacancy[field]) {
        field = 'description'
      }

      return vacancy[field]
    },
    getVacancyUrl(vacancy) {
      return `/${this.lang}/vacancies/${vacancy.slug}`
    },
    goToBlock: function (event) {
      event.preventDefault()
      let link = event.target.getAttribute('href')
      let element = document.querySelector(link);
      const yOffset = document.getElementsByClassName('header')[0].getBoundingClientRect().height;
      const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset - 20;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    handleScroll(event, element) {
      if (window.scrollY > 58) {
        element.classList.add('top')
      } else {
        element.classList.remove('top')
      }
    }

  }
}
</script>

<style lang="scss">
@media (max-width: 767px) {

  .hideHeader {
    header {
      transform-origin: 50% 0;
      transform: scale(1, 0);
    }

    & ~ .with-us {
      .main__navbox {
        transform: translate(0px, -56px);
      }
    }
  }
}


</style>

<style scoped>
.vacancy .title {
  cursor: pointer;
}
</style>
